/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByNegativeUserIntentV2Kind =
  (typeof GroupByNegativeUserIntentV2Kind)[keyof typeof GroupByNegativeUserIntentV2Kind];

export const GroupByNegativeUserIntentV2Kind = {
  negative_user_intent_v2: 'negative_user_intent_v2',
} as const;
